import axios from 'axios';
import { getAPIHost } from '../utils/helper';
import '../utils/axios-interceptor';

export default {
  async getClaimLeaves(year) {
    try {
      let rc = await axios.get(`${getAPIHost()}/api/index.php/absence/allocateRC`);

      if (rc?.data?.status) {
        let records = await axios.get(
          `${getAPIHost()}/api/index.php/claimleave/list?year=${year ?? new Date().getFullYear()}`,
        );

        if (records?.data?.statusCode === 200 && records?.data?.status === 'OK') {
          return records?.data?.result;
        }
      } else {
        return 'error';
      }
    } catch (error) {
      console.error(error);
    }
    return [];
  },

  // async getExpiringRLList() {
  //   const records = await axios.get(`${getAPIHost()}/api/index.php/claimleave/listExpiringRL`);
  //   return records.data.result || [];
  // },
};
